import {
  Box,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Grid,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  DialogActions,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AddIcon from "@mui/icons-material/Add";

export function DriverDetailsDialog({
  isDialogOpen,
  handleCloseDialog,
  selectedDriver,
  wareHouseList,
  reportingCenter,
  licenceExpireryDate,
}) {
  const commonImage = (index, row) => {
    let imageTitle = "Add Image";
    let imageUrl = "";
    if (index === 0) {
      imageTitle = "Add Photo";
      imageUrl = row?.profileImageUrl;
    } else if (index === 1) {
      imageTitle = "Add Driver ID";
      imageUrl = row?.nationalIdImageUrl;
    } else if (index === 2) {
      imageTitle = "Add Licence";
      imageUrl = row?.licenseIdImageUrl;
    }
    return (
      <Box
        sx={{
          border: "2px dashed #BDBDBD",
          borderRadius: "8px",
          height: "120px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#F8F8F8",
        }}
      >
        {imageUrl ? (
          <img
            src={ imageUrl.includes('default.png')|| imageUrl.trim()===''?'https://upload.wikimedia.org/wikipedia/commons/c/cd/Portrait_Placeholder_Square.png':imageUrl}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "8px",
            }}
          />
        ) : (
          <IconButton disabled>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <AddIcon fontSize="large" style={{ color: "#9E9E9E" }} />
              <span style={{ fontSize: "12px" }}> {imageTitle}</span>
            </div>
          </IconButton>
        )}
      </Box>
    );
  };

  const CommonTextField = ({ lable, value }) => {
    return (
      <TextField
        label={lable}
        value={value}
        fullWidth
        margin="normal"
        disabled
        InputProps={{ readOnly: true }}
      />
    );
  };
  return (
    <Dialog
      open={isDialogOpen}
      onClose={handleCloseDialog}
      barrierDismissible={false}
      sx={{
        "& .MuiDialog-paper": {
          width: "700px",
        },
      }}
    >
      <DialogTitle>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          Driver Information
          <div onClick={handleCloseDialog}>
            <CloseIcon
              style={{ width: "24px", height: "24px", cursor: "pointer" }}
            />
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <div
          style={{
            fontSize: "12px",
            fontWeight: "600",
            letterSpacing: "1px",
          }}
        >
          <span style={{ color: "#6F727A" }}>Driver Details</span>
          <span
            style={{
              color: "#6F727A",
              fontStyle: "italic",
              marginLeft: "5px",
            }}
          >
            (View Only)
          </span>
        </div>
        <CommonTextField lable="Name" value={selectedDriver?.name || ""} />

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <CommonTextField
              lable="Phone Number"
              value={selectedDriver?.phoneNumber || ""}
            />
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth margin="normal" disabled>
              <Select value={reportingCenter || ""} displayEmpty>
                <MenuItem value="" disabled>
                  Reporting Center
                </MenuItem>

                {wareHouseList.map((option) => (
                  <MenuItem key={option.locationId} value={option.locationName}>
                    {option.locationName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <CommonTextField lable="Email" value={selectedDriver?.email || ""} />

        <div
          style={{
            fontSize: "12px",
            fontWeight: "600",
            letterSpacing: "1px",
            margin: "5px 0px",
          }}
        >
          <span style={{ color: "#6F727A" }}>Driver Details</span>
          <span
            style={{
              color: "#6F727A",
              fontStyle: "italic",
              margin: "5px",
            }}
          >
            (View Only)
          </span>
        </div>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <CommonTextField
              label="Licence number"
              value={selectedDriver?.licenseCode || ""}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Licence Expire Date"
              value={licenceExpireryDate}
              disabled
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton disabled>
                      <CalendarTodayIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              fullWidth
              margin="normal"
            />
          </Grid>
        </Grid>
        <span
          style={{
            color: "#6F727A",
            margin: "5px 0px",
            fontSize: "12px",
            fontWeight: "600",
          }}
        >
          UPLOAD FILES
        </span>
        <Grid
          container
          spacing={2}
          style={{ marginTop: "1px", marginBottom: "5px" }}
        >
          {[...Array(3)].map((item, index) => (
            <Grid item xs={4} key={index}>
              {commonImage(index, selectedDriver)}
            </Grid>
          ))}
        </Grid>
        <span
          style={{
            color: "#6F727A",

            fontSize: "12px",
            fontWeight: "600",
          }}
        >
          *You should upload PNG and JPG format only.
        </span>
      </DialogContent>
      <DialogActions></DialogActions>
    </Dialog>
  );
}
